"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Original = _interopRequireDefault(require("./templates/Original"));
var _BorderedType = _interopRequireDefault(require("./templates/BorderedType"));
var templates = {
  BorderedType: _BorderedType["default"],
  Original: _Original["default"]
};
var Collapse = function Collapse(props) {
  var TemplateSelected = templates[props.template];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-collapse no-border"
  }, /*#__PURE__*/_react["default"].createElement(TemplateSelected, props));
};
Collapse.propTypes = {
  template: _propTypes["default"].string,
  heading: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  noPadding: _propTypes["default"].bool,
  noBorder: _propTypes["default"].bool,
  lgHeader: _propTypes["default"].bool,
  flip: _propTypes["default"].bool,
  on: _propTypes["default"].bool,
  inlineHeader: _propTypes["default"].bool,
  toggle: _propTypes["default"].func,
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired,
  className: _propTypes["default"].string,
  inlineChevron: _propTypes["default"].bool,
  isActive: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  title: _propTypes["default"].string,
  onlyOpen: _propTypes["default"].bool,
  setActiveChild: _propTypes["default"].func,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Collapse.defaultProps = {
  template: 'Original',
  isActive: false,
  onlyOpen: false
};
var _default = exports["default"] = Collapse;